module.exports = {
  "rides_ride_audience": "Ride audience",
  "cards_entries_list_button": "Show all",
  "roompicker_add_room": "Add room",
  "roompicker_room": "Room",
  "guestpicker_ageselection_description": "when you are on holiday",
  "searchwidget_departure": "Check out",
  "guestpicker_age": "age",
  "supplier_lodging": "lodging",
  "calendar_clear_selection": "Clear selection",
  "roompicker_rooms": "Rooms",
  "rides_min_height": "Minimum height",
  "rides_age_req": "Age requirements",
  "rides_thrill_level": "Thrill level",
  "rides_icon_details": "Click for icon description or click for more details.",
  "searchwidget_arrival": "Check in",
  "supplier_restaurant": "restaurant",
  "rides_max_height": "Maximum height",
  "rides_tickets": "Tickets per guest",
  "supplier_skistation": "skistation",
  "rides_accesibility_title": "Accessibility Information",
  "keywords": "Palabras clave",
  "searchwidget_booknow": "Book now",
  "guestpicker_ageselection_title": "Age of guests"
}